'use es6';

import { createSelector } from 'reselect';
import { DIALOG } from 'DesignData/enums/AppContexts';
import { LAYOUT, TEMPLATE, CUSTOM_WIDGET, RAW_ASSET, GLOBAL_WIDGET, FOLDER, SETTINGS } from 'DesignData/enums/DesignAssetTypes';
import { NONE } from 'DesignData/enums/settings/Categories';
export const getIsDialog = state => state.app.context === DIALOG;

const getActiveEditor = state => state.app.activeEditor;

const getActiveEditorEditorOptions = state => getActiveEditor(state).editorOptions;

export const getActiveSettingsEditorCategory = state => getActiveEditorEditorOptions(state).settingsCategory || NONE;
export const getActiveAssetType = state => getActiveEditor(state).assetType;
export const getIsFinderShowing = state => state.app.isFinderShowing;
export const getIsKeyboardShortcutsListingShowing = state => state.app.isKeyboardShortcutsListingShowing;
export const getShowGlobalContentMessage = state => state.app.showGlobalContentMessage;
export const getFinderWidth = state => state.app.finderWidth;
export const getAlwaysShowFinderOnStartup = state => state.app.alwaysShowFinderOnStartup;
export const shouldUpdatePreviewer = state => state.app.updatePreviewer;
export const getHasDismissedResponsiveImageWarning = state => state.app.hasDismissedResponsiveImageWarning;
export const getHasDismissedIconSetWarning = state => state.app.hasDismissedIconSetWarning;
export const getHasDismissedShowLoadingControls = state => state.app.hasDismissedShowLoadingControls;
export const getHasDismissedAdvancedRelOptionsWarning = state => state.app.hasDismissedAdvancedRelOptionsWarning;
export const getHasDismissedAdvancedVideoOptionsWarning = state => state.app.hasDismissedAdvancedVideoOptionsWarning;
export const getPinnedTabs = state => state.app.pinnedTabs;
export const getActiveAssetId = (state, props) => {
  if (props && props.assetId) return props.assetId;
  return getActiveEditor(state).assetId;
};
export const getActiveRevisionId = state => getActiveEditorEditorOptions(state).revisionId;
/**
 * @return {Boolean}
 */

export const isLayoutEditorActive = createSelector([getActiveAssetType], assetType => {
  return assetType === LAYOUT;
});
/**
 * @return {Boolean}
 */

export const isCodeEditorActive = createSelector([getActiveAssetType], assetType => {
  return assetType === TEMPLATE;
});
/**
 * @return {Boolean}
 */

export const isCustomWidgetEditorActive = createSelector([getActiveAssetType], assetType => {
  return assetType === CUSTOM_WIDGET;
});
/**
 * @return {Boolean}
 */

export const isGlobalWidgetEditorActive = createSelector([getActiveAssetType], assetType => {
  return assetType === GLOBAL_WIDGET;
});
/**
 * @return {Boolean}
 */

export const isRawAssetEditorActive = createSelector([getActiveAssetType], assetType => {
  return assetType === RAW_ASSET;
});
export const isFolderEditorActive = createSelector([getActiveAssetType], assetType => {
  return assetType === FOLDER;
});
/**
 * @return {Boolean}
 */

export const getIsSettingsEditorActive = state => getActiveAssetType(state) === SETTINGS;
/**
 * @return {(Number|String|Null)}
 */

export const getActiveLayoutId = createSelector([isLayoutEditorActive, getActiveAssetId], (isActive, layoutId) => {
  if (!isActive) {
    return null;
  }

  return layoutId;
});
/**
 * @return {(Number|String|Null)}
 */

export const getTemplateId = createSelector([isCodeEditorActive, getActiveAssetId], (isActive, templateId) => {
  if (!isActive) {
    return null;
  }

  return templateId;
});
/**
 * @return {(Number|String|Null)}
 */

export const getCustomWidgetId = createSelector([isCustomWidgetEditorActive, getActiveAssetId], (isActive, customWidgetId) => {
  if (!isActive) {
    return null;
  }

  return customWidgetId;
});
/**
 * @return {(Number|String|Null)}
 */

export const getActiveGlobalWidgetId = createSelector([isGlobalWidgetEditorActive, getActiveAssetId], (isActive, globalWidgetId) => {
  if (!isActive) {
    return null;
  }

  return globalWidgetId;
});
/**
 * @return {(Number|String|Null)}
 */

export const getRawAssetId = createSelector([isRawAssetEditorActive, getActiveAssetId], (isActive, rawAssetId) => {
  if (!isActive) {
    return null;
  }

  return rawAssetId;
});
/**
 * @return {(Number|String|Null)}
 */

export const getFolderId = createSelector([isFolderEditorActive, getActiveAssetId], (isActive, folderId) => {
  if (!isActive) {
    return null;
  }

  return folderId;
});